import React from "react"

import { useTranslation } from "react-i18next"

import { RadioButton, Tooltip } from "@synapse-analytics/synapse-ui"
import { v4 as uuidv4 } from "uuid"

type Props = {
  handleOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  checkedFeat: boolean
  checkedValue: boolean
  margin?: string
  isDisabled?: boolean
  shouldDisableFeature?: boolean
}

export function RadioButtonsCondition({
  handleOnChange,
  checkedFeat,
  checkedValue,
  isDisabled = false,
  shouldDisableFeature,
  margin,
}: Readonly<Props>): React.ReactElement {
  const { t } = useTranslation("common")
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        margin: margin ?? "0px",
        minWidth: "70px",
      }}
    >
      <Tooltip title={shouldDisableFeature ? t("radioButtonsCondition.cannotSelectFeature") : ""}>
        <RadioButton
          value={"Feature"}
          onChange={(e) => handleOnChange(e)}
          checked={checkedFeat}
          label={t("radioButtonsCondition.feature")}
          id={`Feature-${uuidv4()}`}
          disabled={isDisabled || shouldDisableFeature}
          style={{ marginBottom: "0.2rem" }}
        />
      </Tooltip>

      <RadioButton
        value="Value"
        onChange={(e) => handleOnChange(e)}
        checked={checkedValue}
        disabled={isDisabled}
        label={t("radioButtonsCondition.value")}
        id={`value-${uuidv4()}`}
      />
    </div>
  )
}
